import { defineComponent } from 'vue';
import { generateColor } from '../util';
const ColorClear = defineComponent({
    name: 'ColorClear',
    props: ['prefixCls', 'value', 'onChange', 'colorCleared'],
    setup(props) {
        const handleClick = () => {
            if (props.value && !props.colorCleared) {
                const hsba = props.value.toHsb();
                hsba.a = 0;
                const genColor = generateColor(hsba);
                props.onChange?.(genColor);
            }
        };
        return () => <div class={`${props.prefixCls}-clear`} onClick={handleClick}/>;
    },
});
export default ColorClear;
